var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',_vm._g(_vm._b({class:{ '-is-waiting': _vm.isWaiting }},'ActionButton',_vm.buttonProps,false),_vm.$listeners),[(_vm.isWaiting)?_c('Spinner',{staticClass:"-action-button",class:_vm.spinnerModifiers,attrs:{"message":_vm.spinnerMessage,"data-test-id":"spinner"}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }